/**
 * Announcement class
 */
export default class {
  constructor (data) {
    this.id = ~~data.id
    this.name = data.name
    this.pin = data.pin
    this.lang = data.dest_lang
    this.ttsLanguage = data.language
    this.formattedPostDest = data.formatted_post_dest
    this.pitch = data.pitch
    this.speed = data.speed
    this.textType = data.text_type
    this.volumeGainDb = data.volume_gain_db
    this.voiceType = data.voice_type
    this.textToSpeech = data.text_to_speech
  }
}
